
































import { Vue, Component } from 'vue-property-decorator';
import VoteList from './components/VoteList.vue';
import { OPTHINES } from './config';
import { getWorkType, getAreas } from './api';
import { Tab, Tabs, Picker } from 'vant';

Vue.use(Tab).use(Tabs).use(Picker);
@Component({
  components: {
    VoteList,
  },
})
export default class List extends Vue {
  option = OPTHINES;
  WorkTypeData = [];
  AreasData: any[] = [];
  showPicker: boolean = false;
  value: string = '请选择所属分赛区';
  active: number = 0;
  county: number = 0;
  workType: number = 1;
  type: any;

  created() {
    this.type = this.$route.query.type;
    getWorkType().then((res) => (this.WorkTypeData = Object.values(res.data)));
    getAreas().then((res) => this.fecthAreas(res));
  }
  fecthAreas(res: any) {
    const AreasData = Object.values(res.data);
    this.AreasData.push('全部', ...AreasData);
  }
  onConfirm(e: any, index: number) {
    this.$emit('selectData', e, index);
    this.value = e;
    this.showPicker = false;
    this.county = index;
  }
  onChange(index: number) {
    this.workType = index + 1;
  }
}
